export interface NFTCardItem {
  id?: string;
  loadUrl: string;
  name: string;
  likedBy: number;
  starRank?: number;
  owner?: string;
  isFavorite?: boolean;
  withLikedIcon?: boolean;
  canBeOwned?: boolean;
  isMystery?: boolean;
  isFrozen?: boolean;
}

export enum ClickType {
  NFT_CARD_ITEM,
  NFT_CARD_LIKED_ICON,
  NTF_CARD_MYSTERY,
}

export interface NFTItemClickFunc {
  (itemId: string, clickType: ClickType, liked?: boolean): void;
}

/**
 * Api Model
 */
export interface Category {
  name: string;
  isCategory: boolean;
}
export interface AvatarCategories {
  data: Array<Category>;
}

export interface Trait {
  name: string;
  value: String[];
}

export enum CollectionType {
  AVATAR = "AVATAR",
  COVER = "COVER",
}
export interface AssetsRequestOld {
  stringTraits?: Array<Trait>;
  categories?: Array<Category>;
  collectionType?: CollectionType;
}

export interface PageInfo {
  endCursor: string;
  hasNextPage: boolean;
}

export interface Asset {
  cursor?: string;
  isFrozen?: boolean;
  isFavorite?: boolean;
  owner?: string;
  likedBy: string;
  name: string;
  imageUrl: string;
  tokenId: string;
  backgroundColor?: string;
}
export interface AssetsResponse {
  pageInfo: PageInfo;
  totalCount: number;
  assets: Array<Asset>;
}

/**
 * ##################################################
 */

export interface CategoryTab {
  isAsset: boolean;
  type: string;
  value: string;
  displayNameZh: string;
  displayNameEn: string;
}

export interface AssetsRequest {
  type: string;
  cursor?: string;
  limit?: number;
}

export interface AvatarAssetItem {
  imageId: string;
  imageUrl: string;
  name: string;
  desireCounts: number;
  desiredMyself: boolean;
  owned: boolean;
  starRank: number;
}

export interface AvatarAssetDetail {
  ownerNickname: string;
  ownerUserId: number;
  ownedMyself: boolean;
  usedAsAvatar: boolean;
}

export interface SelectAvatarForProfileRequest {
  imageId: string;
  nickname?: string;
  introduction?: string;
}

/**
 * 股单封面
 */

export interface CoverAssetItem {
  coverId: string;
  coverUrl: string;
  name: string;
  desireCounts: number;
  desiredMyself: boolean;
  usedAsCover: boolean;
}

/**
 * 头像
 */
export interface AvatarAssetItem {
  imageId: string;
  imageUrl: string;
  name: string;
  desireCounts: number;
  desiredMyself: boolean;
  canBeOwned: boolean;
}

/**
 * 头像拥有人
 */
export interface AvatarOwner {
  ownerNickname: string;
  ownerUserId: string;
}

/**
 * 用于头像params
 */
export interface PostOwnAvatarParams {
  nickname: string;
}

/**
 * 拥有礼包
 */
export interface MysteryModel {
  hasQualifications: boolean;
  list: {
    type: number;
    quotas: number;
    consumedQuotas: number;
  }[];
}

/**
 * 入金等级&avatar拥有
 */
export interface AvatarQuotaResponse {
  depositAmount: number; // 入金金额
  depositCurrency: string; // 货币单位
  hasOwned: boolean; // 是否已经拥有过头像
  canOwned?: boolean; // 是否可以拥有头像(hasOwned 返回true时此字段不反回)
  canOwnedTopStarLevel?: number; // 可拥有头像的最高星级(1-5)(hasOwned 返回true时此字段不反回)
}
